import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp, FaBullseye } from 'react-icons/fa';

const EFFORT_LABELS = { low: 'Bajo', medium: 'Medio', high: 'Alto' };

const priorityClass = (p) => {
  const n = Number(p);
  if (n <= 1) return 'rec-priority-1';
  if (n === 2) return 'rec-priority-2';
  if (n === 3) return 'rec-priority-3';
  if (n === 4) return 'rec-priority-4';
  return 'rec-priority-5';
};

const RecommendationsWidget = ({ data }) => {
  const { summary, items = [] } = data || {};
  const [expanded, setExpanded] = useState({});

  const toggle = (idx) => setExpanded((p) => ({ ...p, [idx]: !p[idx] }));

  if (!items.length) {
    return (
      <div className="rec-widget-empty">
        {summary || 'Sin recomendaciones disponibles.'}
      </div>
    );
  }

  return (
    <div className="rec-widget-body">
      {summary && <p className="rec-widget-summary">{summary}</p>}
      <div className="rec-widget-grid">
        {items.map((rec, idx) => {
          const isOpen = !!expanded[idx];
          return (
            <div key={idx} className={`rec-card ${isOpen ? 'open' : ''}`}>
              <button
                type="button"
                className="rec-card-header"
                onClick={() => toggle(idx)}
              >
                <span className={`rec-priority-badge ${priorityClass(rec.priority)}`}>
                  {rec.priority ?? '·'}
                </span>
                <span className="rec-card-title">{rec.title}</span>
                {isOpen ? <FaChevronUp /> : <FaChevronDown />}
              </button>
              <div className="rec-card-body">
                <p className="rec-card-description">{rec.description}</p>
                {isOpen && (
                  <>
                    {rec.expected_impact && (
                      <div className="rec-card-impact">
                        <FaBullseye />
                        <span><strong>Impacto:</strong> {rec.expected_impact}</span>
                      </div>
                    )}
                    {rec.effort && (
                      <div className="rec-card-effort">
                        Esfuerzo: <strong>{EFFORT_LABELS[rec.effort?.toLowerCase()] || rec.effort}</strong>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RecommendationsWidget;
